// extracted by mini-css-extract-plugin
module.exports = {"trainingTemplate":"styles_trainingTemplate__s6YIF","fileUpload":"styles_fileUpload__1HwGI","attachmentContainer":"styles_attachmentContainer__2YkHD"};